import { AppState } from "store/types";
import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AsyncDispatchResult<R = any | Promise<any>> = ThunkAction<R, AppState, any, AnyAction>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const asyncAction = <T = any>(action: () => AsyncDispatchResult<T>) => {
  return new Promise<T>(async (resolve, reject) => {
    try {
      const result = await action();

      resolve({ ...result } as T);
    } catch (e) {
      reject(e);
    }
  });
};

export default asyncAction;
